import React, { useState, type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  Flex,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  MESSAGE_BOX_VARIANT_TIP,
  MessageBox,
  TEXT_VARIANT_STANDARD,
  TITLE_VARIANT_S,
  Text,
  Title,
} from 'mailup-web-components'

import ModalDataSyncPromo from 'Components/ModalDataSyncPromo'

import { openMshopDataSyncImport } from 'Helpers/ecommerce'

const DataSyncPromoImport: FC = () => {
  const intl = useIntl()

  const [show, setShow] = useState(false)

  const openModal = (): void => {
    setShow(true)
  }

  const handleCancel = (): void => {
    setShow(false)
  }

  return (
    <>
      <ModalDataSyncPromo
        show={show}
        onCancel={handleCancel}
        onConfirm={openMshopDataSyncImport}
      />

      <MessageBox variant={MESSAGE_BOX_VARIANT_TIP}>
        <Flex flexDirection="column" gap="8px">
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({
              id: 'Load.DataSyncPromoImport.MessageTitle',
            })}
          </Title>

          <Text variant={TEXT_VARIANT_STANDARD}>
            {intl.formatMessage(
              { id: 'Load.DataSyncPromoImport.MessageDescription' },
              {
                link: (chunks) => (
                  <Link
                    data-mu-test="data-sync-promo-import__open-modal"
                    variant={LINK_VARIANT_HIGHLIGHT}
                    onClick={openModal}
                  >
                    {chunks}
                  </Link>
                ),
              },
            )}
          </Text>
        </Flex>
      </MessageBox>
    </>
  )
}

export default DataSyncPromoImport
